<ng-template #resultTemplate let-r="result" let-t="term">
    <div class="typeahead-result">
        <span *ngFor="let field of resultFields; let last = last">
            {{ $any(r)[field] }}<span *ngIf="!last">, </span>
        </span>
    </div>
</ng-template>

<ng-container *ngIf="compact; else formLayout">
    <input
        [ngClass]="styleClasses"
        [class.is-invalid]="showError || searchFailed"
        type="text"
        [id]="inputId"
        autocomplete="off"
        [placeholder]="placeholder"
        [formControl]="inputControl"
        [ngbTypeahead]="typeaheadSearch"
        [inputFormatter]="formatter"
        [resultFormatter]="resultFormatter"
        [resultTemplate]="resultTemplate"
        [editable]="false"
        (selectItem)="onSelect($event)"
        (blur)="onBlur()"
        (input)="onInputChange()" />
    <small *ngIf="searching" class="text-secondary d-block">Buscando...</small>
</ng-container>

<ng-template #formLayout>
    <div class="mb-3 row">
        <label [attr.for]="inputId" class="col-sm-4 col-form-label">
            {{ label }}
            <sup *ngIf="required" class="text-danger">*</sup>
        </label>
        <div class="col-sm-8">
            <input
                class="form-control"
                [class.is-invalid]="showError || searchFailed"
                type="text"
                [id]="inputId"
                autocomplete="off"
                [placeholder]="placeholder"
                [formControl]="inputControl"
                [ngbTypeahead]="typeaheadSearch"
                [inputFormatter]="formatter"
                [resultFormatter]="resultFormatter"
                [resultTemplate]="resultTemplate"
                [editable]="false"
                (selectItem)="onSelect($event)"
                (blur)="onBlur()"
                (input)="onInputChange()" />
            <small *ngIf="searching" class="text-secondary">Buscando...</small>
            <div *ngIf="showError" class="text-danger">
                {{ requiredError }}
            </div>
        </div>
    </div>
</ng-template>
